import { Page } from "@/models/page-models/Page";

export const SalesTarget: Page = {
  "path": "monthly-sales-status",
  "name": "Monthly Sales Expectation",
  "props": {
    "data":{
      "title": "Monthly Sales Expectation",
      "printable": "FALSE",
      "url": "monthly-sales-status",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.month",
                  "label": "Select Month",
                  "disabled": "FALSE",
                  "items": "[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2023,2024,2025,2026,2027]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.groups",
                  "label": "Sales Group",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getMonthlyTargetValues",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/order/get-monthly-sales-target-report",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.monthlyTargetValues",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getMonthlyTargetValues"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "salesTarget",
                  "showIf": "{{fetchedData.monthlyTargetValues.data}}",
                  "monthlyTargetDataVariable": "fetchedData.monthlyTargetValues.data",
                  "formVariable": "formData"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyQueryParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getQueryParams",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyQueryParams"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMonthlyTargetValues",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/order/get-monthly-sales-target-report",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.monthlyTargetValues",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "getMonthlyTargetValues"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/businesspartnergroups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerGroups"
        },
        "name": "getCustomerGroups",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
      }
    ],
    "functions": [
      {
        "name": "getQueryParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})",
          "month": "fn(CONDITIONAL,{{__query.month}},{{__query.month}},{{CURRENT_MONTH_NAME}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 30,
  "menuGroup": "Reports"
}